import React from 'react';
import cn from 'classnames';
import { WpIcon } from 'Wpds/components/icon';

type Props = {
  isOpen: boolean;
  onOpen: (event: React.MouseEvent<HTMLInputElement>) => void;
};

export default function Controls({ onOpen, isOpen }: Props) {
  return (
    <div
      className="d-flex justify-content-between border-bottom align-items-end px-4"
      style={{ fontSize: '11px', lineHeight: '147%', height: '42px' }}
    >
      <p className="mt-0 mb-1 text-uppercase">Seach Results</p>
      <div className="d-flex ">
        <button
          type="button"
          className={cn('btn text-primary shadow-none p-0 mb-1', { invisible: isOpen })}
          style={{ fontSize: '16px', lineHeight: '147%' }}
          onClick={onOpen}
        >
          <span className="mx-1">
            <WpIcon name="plus-circle" />
          </span>
          Add filter
        </button>
      </div>
    </div>
  );
}
